<p-progressBar 
    [value]="percentage" 
    [styleClass]="progressClass">
</p-progressBar>
